<template>
  <div style="height: 100%;">
    <div class="view-header">
      <div class="a-title">{{article.title}}</div>
      <div class="a-info">
        <div style="width: 100%;">
          <div class="a-author">{{article.author_name}}</div>
          <div class="a-date">
            <span>作成日時：{{displayDate(article.created_at)}}</span>
            <span style="padding-left: 24px;">更新日時：{{displayDate(article.updated_at)}}</span>
          </div>
        </div>
        <button class="button" @click="modify()" v-if="article.author = user.userHash">記事修正</button>
        <button class="button" @click="back()">戻る</button>
      </div>
    </div>
    <div class="wrapper">
      <div class="ql-editor" v-html="article.body"></div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import moment from 'moment'

export default {
  name: 'ArticleView',
  props: ['aID'],
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('virtualOffice', ['articles']),
    article () {
      return this.articles.find(f => f.id == this.aID)
    },
  },
  data () {
    return {
    }
  },
  methods: {
    back () {
      this.$emit('back', null)
    },
    modify () {
      this.$emit('modify', this.article.id)
    },
    displayDate (d) {
      return moment(d).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>

<style scoped lang="scss">
.view-header {
  margin-bottom: 8px;
}

.a-title {
  font-size: 25px;
  font-weight: bold;
  width: 100%;
  white-space: nowrap;
  overflow-x: scroll;
  margin-bottom: 8px;
}

.a-info {
  display: flex;

  button {
    margin-top: auto;
    margin-left: 8px;
  }
}

.a-author {
  font-size: 18px;
  overflow-x: hidden;
  margin-bottom: 4px;
}

.a-date {
  font-size: 15px;
}

.wrapper {
  width: 100%;
  height: calc(100% - 106px);
  overflow-y: scroll;
}

.ql-editor {
  border: ridge 1px black;
  height: auto;
  min-height: 100%;
  border-radius: 8px;
}

.ql-editor /deep/ h1{
  font-size: 2em;
  font-weight: bold;
}

.ql-editor /deep/ h2{
  font-size: 1.5em;
  font-weight: bold;
}

.ql-editor /deep/ h3{
  font-size: 1.17em;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/Forum/ArticleView.vue